import styled from 'styled-components';

export const StyledRoutineKpiBar = styled.div``;
